var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "errPage-container" },
    [
      _c(
        "el-button",
        {
          staticClass: "pan-back-btn",
          attrs: { size: "small", icon: "el-icon-arrow-left" },
          on: { click: _vm.back },
        },
        [_vm._v(" 返回 ")]
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("h1", [_vm._v("你没有权限去该页面")]),
              _c(
                "router-link",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { to: "/dashboard" },
                },
                [_vm._v(" 回首页 ")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-top": "12px", display: "block" },
                  attrs: { type: "text" },
                  on: { click: _vm.handleReLogin },
                },
                [_vm._v("返回重新登录")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }